import { Model } from "../alcance/models/model";
import { Pessoa } from "../alcance/models/pessoa";
import { Cliente } from "./cliente";
import { Edificacao } from "./edificacao";
import { Grupo } from "./grupo";

export class Estabelecimento extends Model{
    private _edificacoes!: Edificacao[];

    cliente!: Cliente;
    cliente_id!: number;
    pessoa!: Pessoa;
    uf!: string;
    grupo_id!: number;
    grupo!: Grupo;
    imagem?: string;
    conf!: EstabelecimentoConf;
    updated_at!: string;

    get edificacoes(): Edificacao[] {
        return this._edificacoes;
    }

    set edificacoes(e: Edificacao[]){
        let eds: Edificacao[] = [];
        e.forEach((v) => {
            eds.push(new Edificacao(v))
        })
        this._edificacoes = eds;
    }
}

export interface EstabelecimentoConf{
    block_equipamento: boolean; // bloqueia edição no app
    silenciar_alarme_apos_primeiro_acionamento_sinistro?: boolean; // evita repetir alarme no mesmo sinistro
    draw_edificacao: boolean; //pode desenhar
    exe_atividade: boolean; //antes do vencimento
    exe_atividade_no_mes?: boolean; //antes do vencimento apenas dentro do mes da vigencia
    img_atividade: boolean; //obriga imagem
    prazo_pendencia: boolean; //obriga prazo
    mail_pendencia: boolean; //obriga email
    required_responsavel_pendencia: boolean; //obriga informar responsavel em pendecias
    required_pendencia: boolean; //obriga cadastro de pendencia em não conformidade de inspeção
    signature_required_atividade : boolean; //obriga assinar a execução da inspeção
    assinatura_relatorios?: boolean;
    // MOVIDO PARA O ITEM DO CHECKLIST
    // multiple_pendencia: boolean; //permite cadastrar mais de um pendencia em não conformidade de inspeção
    required_checklist_inspecao: boolean; //obriga selecionar sim não ou informar valor no checklist da inspeção
	add_email_inspecao: boolean; //Permite adicionar email na inspeção
    aprovar_pendencia: boolean; //se as pendências passam por aprovação
    aprovar_resolucao_pendencia: boolean; //se as resoluções de pendências passam por aprovação
    marcar_todos_checklist_inspecao: boolean; //mostra botão para marcar todos os checklist das inspeções
    brigadista_can_change_dados: boolean;
    brigadista_disable_change_status: boolean;
    bloquear_dt_plantao?: boolean; // bloqueia alteracao da data e hora do relatorio de turno
    marcar_checklist_inspecao_anterior: boolean; //Marca os checklists com os dados da última inspeção
    ocultar_indice_atividade: boolean; // Oculta o indice da inspeção
    galeria?: {[modulo: string]: boolean}; // Permite foto da galeria por módulo
    enable_galeria?: boolean; // Configuração geral anterior, mantida para compatibilidade
    imagem_pendencia: boolean; //Abre a pendencia com a foto da execução da atividade

	setar_controle_equipamento: boolean;
    edt_dados_inspecao_equipamento?: boolean;
    edt_dados_inspecao_atividade?: boolean;
	ignora_categoria_equipamento: boolean;
	desativar_troca_equipamento_inspecao?: boolean;
	desativar_inversao_equipamento_inspecao?: boolean;
	desativar_posicao_vazia_inspecao?: boolean;
	desativar_lancar_estoque_inspecao?: boolean;
	// sobrescrever_controle_equipamento: boolean;
}
